module.exports = __webpack_public_path__ + "static/media/DRREDDY_F1.989854e8.txt";